import { useDealContext } from "../../deal/context";

export const CompanyOutreach = () => {

    const { dealContext } = useDealContext();
    const project = dealContext.project;

    return <div>Outreach</div>;
}